import { render } from "./gaji-rekap.vue?vue&type=template&id=1368934e"
import script from "./gaji-rekap.vue?vue&type=script&lang=js"
export * from "./gaji-rekap.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__